import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * request for getting order list
 * @param {Object} filters filters object containing filter parameters
  * @param {Number} filters.page page number
  * @param {Number} filters.size data size each page
  * @param {String} filters.sort filed;ASC|DESC
  * @param {Number} filters.dateFrom date long
  * @param {Number} filters.dateTo date long
  * @param {Number} filters.shipperId shipper id
  * @param {String} filters.shipperName shipper name
  * @param {Number} filters.transporterId transporter id
  * @param {String} filters.transporterName transporter name
  * @param {Number} filters.originId origin id
  * @param {String} filters.origin origin name
  * @param {Number} filters.destinationId destination id
  * @param {String} filters.destination destionation name
  * @param {Array} filters.status shipping status strings
  * @param {Number} filters.shipmentNo order number
  * @param {Number} filters.selfOrder 1 (Own) : 0 (all)
 */
const fetchOrders = async function (filters) {
  try {
    let data = {
      page: filters.page - 1,
      size: filters.size
    }
    if (filters.sort) data.sort = filters.sort
    if (filters.dateFrom) data.dateFrom = filters.dateFrom
    if (filters.dateTo) data.dateTo = filters.dateTo
    if (filters.shipperId) data.shipperId = filters.shipperId
    if (filters.shipperName) data.shipperName = filters.shipperName
    if (filters.transporterId) data.transporterId = filters.transporterId
    if (filters.transporterName) data.transporterName = filters.transporterName
    if (filters.originId) data.originId = filters.originId
    if (filters.origin) data.origin = filters.origin
    if (filters.destinationId) data.destinationId = filters.destinationId
    if (filters.destination) data.destination = filters.destination
    if (filters.status.length) data.status = filters.status
    if (filters.shipmentNo) data.shipmentNo = filters.shipmentNo
    if (filters.selfOrder) data.selfOrder = filters.selfOrder
    if (filters.calculationStatus && filters.calculationStatus.length) data.calculationStatus = filters.calculationStatus
    if (filters.groupId) data.groupId = filters.groupId

    console.log('TCL: fetchOrders -> data', urls.orderList + `?${querystring.stringify(data)}`)
    let res = await axios.get(urls.orderList + `?${querystring.stringify(data)}`)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * request for getting shipment group list
 * @param {Object} filters filters object containing filter parameters
  * @param {Number} filters.page page number
  * @param {Number} filters.size data size each page
  * @param {String} filters.sort filed;ASC|DESC
  * @param {Number} filters.dateFrom date long
  * @param {Number} filters.dateTo date long
  * @param {Number} filters.shipperId shipper id
  * @param {String} filters.shipperName shipper name
  * @param {Number} filters.transporterId transporter id
  * @param {String} filters.transporterName transporter name
  * @param {Number} filters.originId origin id
  * @param {String} filters.origin origin name
  * @param {Number} filters.destinationId destination id
  * @param {String} filters.destination destionation name
  * @param {Array} filters.status shipping status strings
  * @param {Number} filters.shipmentNo order number
  * @param {Number} filters.selfOrder 1 (Own) : 0 (all)
 */
const fetchShipmentGroupList = async function (filters) {
  try {
    let data = {
      page: filters.page - 1,
      size: filters.size
    }
    if (filters.sort) data.sort = filters.sort
    if (filters.dateFrom) data.dateFrom = filters.dateFrom
    if (filters.dateTo) data.dateTo = filters.dateTo
    if (filters.shipperId) data.shipperId = filters.shipperId
    if (filters.shipperName) data.shipperName = filters.shipperName
    if (filters.transporterId) data.transporterId = filters.transporterId
    if (filters.transporterName) data.transporterName = filters.transporterName
    if (filters.originId) data.originId = filters.originId
    if (filters.origin) data.origin = filters.origin
    if (filters.destinationId) data.destinationId = filters.destinationId
    if (filters.destination) data.destination = filters.destination
    if (filters.status.length) data.status = filters.status
    if (filters.shipmentNo) data.shipmentNo = filters.shipmentNo
    if (filters.selfOrder) data.selfOrder = filters.selfOrder
    if (filters.calculationStatus && filters.calculationStatus.length) data.calculationStatus = filters.calculationStatus

    let queryStringData = querystring.stringify(data)
    console.log('fetchShipmentGroupList -> queryStringData', queryStringData)
    let res = await axios.get(urls.shipmentGroupList + `?${queryStringData}`)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch shipment list by group id
 * @param {Number} id shipment group id
 */
const fetchShipmentListByGroupId = async function (id) {
  try {
    let data = {
      groupId: id,
      page: 0,
      size: 1000,
    }
    let queryStringData = querystring.stringify(data)

    let res = await axios.get(urls.shipmentListByGroupId + `?${queryStringData}`)
    return res.data
  } catch (error) {
    console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

/**
 * fetch shipment group's detail
 * @param {Number} id shipment id
 */
const fetchShipmentGroupDetail = async function (id) {
  try {
    let res = await axios.get(urls.shipmentGroupDetail + '/' + id)
    return res.data
  } catch (error) {
    console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

/**
 * fetch order's detail
 * @param {Number} id order id
 */
const fetchOrderDetail = async function (id) {
  try {
    let res = await axios.get(urls.orderDetail + '/' + id)
    return res.data
  } catch (error) {
    console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

/**
 * fetch documents for an order
 * @param {Number} orderId order Id
 * @param {String} type Document Type
 */
const fetchOrderDocuments = async function (orderId, type) {
  try {
    let res = await axios.get(urls.orderDocuments(orderId, type))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Update order document completion status
 * @param {Number} orderId order id
 * @param {Number} isComplete completion status in binary (0/1)
 */
const updateDocumentCompletionStatus = async function (orderId, isComplete) {
  try {
    let data = {
      shipmentId: orderId,
      complete: isComplete,
    }
    let res = await axios.put(urls.orderDocumentCompletion, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch quantity info
 * @param {Number} orderId order id
 */
const fetchQuantityInfo = async function (orderId) {
  try {
    let data = {
      shipmentId: orderId
    }
    let res = await axios.get(urls.orderQuantity + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * update unit quantity in an order
 * @param {Number} orderId order id
 * @param {Object} form unit detail form
 * @param {String} form.unit unit of measurement of choice
 * @param {Array} form.unitDetail array of object with delivery note number and qty ammount
 * @param {Boolean} isEdit if is editing
 */
const updateQuantityInfo = async function (orderId, form, isEdit) {
  try {
    let data = {
      shipmentId: orderId,
      ...form
    }
    let res
    if (isEdit) {
      res = await axios.put(urls.orderQuantity, data)
    } else {
      res = await axios.post(urls.orderQuantity, data)
    }
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch order status updates history
 * @param {Number} id order id
 */
const fetchOrderStatusHistory = async function (id) {
  try {
    let res = await axios.get(urls.orderStatusHistory(id))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch order summary
 * @param {Number} todayDate requested date summary
 */
const fetchOrderSummary = async function (todayDate) {
  try {
    let data = {
      todayDate: new Date(todayDate).setHours(0, 0, 0, 0)
    }
    let res = await axios.get(urls.orderSummary + `?${querystring.stringify(data)}`)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch transporter list to be assigned to an order
 * @param {Number} search search value
 * @param {Number} orderId order id for transporter to be assigned to
 * @param {Number} page available transprter list page number, starts from 0
 * @param {Number} size transporter list size per page
 * @param {String} sort sort transporter by, format: field;ASC|DESC
 */
const fetchAvailableTransporters = async function (search, shipmentGroupId, page, size, sort) {
  try {
    let filters = {
      page, size, sort, search
    }
    let res = await axios.get(urls.availableTransporters(shipmentGroupId) + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch transporter's available vehicles
 * @param {Number} search search value
 * @param {Number} orderId order id for vehicle to be assigned to
 * @param {Number} transporterId transporter id for the requested vehicles
 * @param {Number} page available vehicle list page number, starts from 0
 * @param {Number} size vehicle list size per page
 * @param {String} sort sort vehicle by, format: field;ASC|DESC
 */
const fetchAvailableVehicles = async function (search, shipmentGroupId, transporterId, page, size, sort) {
  try {
    let filters = {
      page, size, sort, search
    }
    let res = await axios.get(urls.availableVehicles(shipmentGroupId, transporterId) + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * assign an order to a transpoter
 * @param {Number} orderId order which transporter to be assigned to
 * @param {Number} transporterId transporter to be assigned
 * @param {Number} transportId transport to be used for the shipment
 * @param {Number} [referenceShipmentId] shipment id to be continued from
 * @param {Number} [lat] new pickup location latitude
 * @param {Number} [lng] new pickup location longitude
 * @param {Boolean} [isReassign] new pickup location longitude
 */
const assignTransporter = async function ({ shipmentGroupId, transporterId, transportId, referenceShipmentId, lat, lng, isReassign }) {
  try {
    let data = Object.assign({},
      {
        shipmentGroupId,
        transporterId: transporterId,
        transportId: transportId,
      },
      referenceShipmentId === null ? undefined : { reffShipmentId: referenceShipmentId },
      lat === null ? undefined : { lat },
      lng === null ? undefined : { lng },
    )
    let res =
    isReassign
      ? await axios.post(urls.reassignTransporter, data)
      : await axios.post(urls.assignTransporter, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Fetch calculated quantity
 * @param {Number} orderId order id
 */
const fetchCalculatedQuantity = async function (orderId) {
  try {
    let res = await axios.get(urls.orderCalculatedQuantity + '?shipmentId=' + orderId)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * cancel an order
 * @param {Number} orderId order id
 * @param {String} note canncellaation note
 */
const cancelOrder = async function (orderId, note) {
  try {
    let data = {
      shipmentId: orderId,
      reason: note
    }
    let res = await axios.post(urls.orderCancel, data)
    console.log('TCL: res', res)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * update order/shipment status
 * @param {Number} orderId order/shipmentId
 * @param {String} nextStatus next status
 * @param {Number} lat vehicle lat location
 * @param {Number} lng vehicle lng location
 * @param {String} note update status note
 */
const updateOrderStatus = async function (orderId, { nextStatus, lat, lng, notes }) {
  try {
    let data = [{
      shipmentId: orderId,
      nextStatus,
      lat,
      lng,
      notes,
    }]
    console.log('TCL: data', data)
    let res = await axios.post(urls.orderUpdateStatus, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * update order document
 * @param {Number} orderId order / shipmient Id
 * @param {String} docType document type
 * @param {Array} images document images url
 */
const updateOrderDocuments = async function (orderId, docType, images) {
  try {
    let data = {
      shipmentId: orderId,
      docType,
      images,
    }
    console.log('TCL: data', data)
    let res = await axios.post(urls.orderDocumentUpdate, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch unit option for quantity input from contract
 * @param {Number} orderId order / shipment Id
 */
const fetchUnitOptionsFromContract = async function (orderId) {
  try {
    let res = await axios.get(urls.orderContractUnitOptions + '?' + querystring.stringify({ shipmentId: orderId }))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchShipmentGroup = async function (filters) {
  try {
    let data = {
      page: filters.page - 1,
      size: filters.size
    }
    if (filters.sort) data.sort = filters.sort
    if (filters.dateFrom) data.dateFrom = filters.dateFrom
    if (filters.dateTo) data.dateTo = filters.dateTo
    if (filters.shipperId) data.shipperId = filters.shipperId
    if (filters.shipperName) data.shipperName = filters.shipperName
    if (filters.transporterId) data.transporterId = filters.transporterId
    if (filters.transporterName) data.transporterName = filters.transporterName
    if (filters.originId) data.originId = filters.originId
    if (filters.origin) data.origin = filters.origin
    if (filters.destinationId) data.destinationId = filters.destinationId
    if (filters.destination) data.destination = filters.destination
    if (filters.status.length) data.status = filters.status
    if (filters.shipmentNo) data.shipmentNo = filters.shipmentNo
    if (filters.selfOrder) data.selfOrder = filters.selfOrder
    if (filters.transportId) data.transportId = filters.transportId
    if (!isNaN(parseInt(filters.completePod))) data.completePod = filters.completePod
    if (filters.calculationStatus && filters.calculationStatus.length) data.calculationStatus = filters.calculationStatus

    console.log('TCL: fetchShipmentGroup -> data', urls.shipmentGroup + `?${querystring.stringify(data)}`)
    let res = await axios.get(urls.shipmentGroup + `?${querystring.stringify(data)}`)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const overwriteShipperConfirm = async function (shipmentId, note) {
  try {
    let data = {
      shipmentId,
      note
    }
    let res = await axios.post(urls.shipmentConfirmation, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * get orderlist available page sizes for table
 */
const orderListPageSizes = async function () {
  try {
    const res = await axios.get(urls.orderListPageSizes)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchOrders,
  fetchOrderDetail,
  fetchOrderStatusHistory,
  fetchOrderSummary,
  fetchAvailableTransporters,
  fetchAvailableVehicles,
  assignTransporter,
  fetchCalculatedQuantity,
  fetchOrderDocuments,
  updateDocumentCompletionStatus,
  updateQuantityInfo,
  fetchQuantityInfo,
  cancelOrder,
  updateOrderStatus,
  updateOrderDocuments,
  fetchUnitOptionsFromContract,
  fetchShipmentGroup,
  fetchShipmentGroupDetail,
  overwriteShipperConfirm,
  fetchShipmentGroupList,
  fetchShipmentListByGroupId,
  orderListPageSizes,
}
